import { setStore } from '../utils/storage'
import { setToken } from '@/utils/auth'
export default {
  // 记录token
  SET_TOKEN: (state, token) => {
    state.tokenInfo = token
    setToken(state.tokenInfo)
  },
  // 记录路由
  SET_ROUTES(state, data) {
    state.routerlist = data
  },
  SET_USERS(state, data) {
    state.classinfo = data
  },
  removerouterlist(state) {
    state.routerlist = []
  },
}
